<template>
  <div class="new-detail-content">
    <img :src="img">
    <img v-if="isshow==5" src="../../assets/img/nygl2.png">
    <div class="anchor" v-if="isshow==2">
      <viewer :images='[anchorimg[0]]'><span><img :src='anchorimg[0]' /></span></viewer>
      <viewer :images='[anchorimg[1]]'><span><img :src='anchorimg[1]' /></span></viewer>
      <viewer :images='[anchorimg[2]]'><span><img :src='anchorimg[2]' /></span></viewer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Infotom',
  data () {
    return {
      img:'',
      isshow:false,
      anchorimg:[require('../../assets/img/al-1.jpg'),require('../../assets/img/al-3.jpg'),require('../../assets/img/al-2.jpg')],
      datas:[
        {id:1,img:require('../../assets/img/xxt.jpg')},
        {id:2,img:require('../../assets/img/hrerp.jpg')},
        {id:3,img:require('../../assets/img/ggd.jpg')},
        {id:4,img:require('../../assets/img/stbq.jpg')},
        {id:5,img:require('../../assets/img/nygl1.png')}
      ]
    }
  },
  created() {
    let ids=this.$route.query.id
    this.isshow=ids
    let getdata=this.datas[this.datas.findIndex((item) => item.id*1 === ids*1)]||{}
    if(getdata){
      this.img=getdata.img
    }
  }
}
</script>

<style scoped>
.new-detail-content{
  width: 100%;
  background: #0A47B6;
  overflow: auto;
  height: 100%;
  position: relative;
}

.new-detail-content::-webkit-scrollbar{
  display: none;
}

.new-detail-content img{
  width: 100%;
  display: inline-block;
}

.anchor{
  position: absolute;
  top:1150px;
  left: 442px;
  width: 1114px;
  height: 59px;
  display: flex;
  justify-content: space-between;
}

.anchor span{
  display: inline-block;
  width: 226px;
  height: 58px;
  cursor: pointer;
  overflow: hidden;
}

.anchor span img{
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-new-Infotom.vue